import Specification from '../../Components/Vimdt/Specification/Specification';

function SpecificationPage() {
	return <Specification />;
}

export default SpecificationPage;
